import { Fragment } from 'react'
import { ImageCitation } from 'components/messages/citations/ImageCitation'
import { AttachmentCitation } from 'components/messages/citations/AttachmentCitation'
import { SourceCitation } from 'components/messages/citations/SourceCitation'
import { CitationSource } from 'types/chat-message'

type CitationTokenProps = {
  /** Marker prefix: 'img:' (image), 'att:' (attachment) or undefined (remote source). */
  flag?: string
  /** The citation number as written in the text. */
  num: string
  sources?: Record<string, CitationSource> | null
}

/**
 * Renders a single inline citation marker. Dispatches to the right citation
 * component by marker kind; falls back to the literal `[num]` when a remote
 * source is missing (so nothing silently disappears).
 */
export const CitationToken = ({ flag, num, sources }: CitationTokenProps) => {
  const source = sources?.[num]

  if (flag === 'img:') return <ImageCitation source={source} />
  if (flag === 'att:') return <AttachmentCitation num={num} source={source} />
  if (!source) return <Fragment>{`[${num}]`}</Fragment>
  return <SourceCitation num={num} source={source} />
}
